import log from 'loglevel';
import { fetchAvatar } from '../../avatars';
import { homeActions } from '../slices/homeSlice';
import { HomeDispatch } from '../store/homeStore';
import { updateAvatar } from './homeAvatar';

type PollState = {
  timer?: any;
};

const GARMENT_FIT_POLL_MILLISECONDS = 1000;

const state: PollState = {
  timer: undefined,
};

/**
 * Begin avatar polling.
 * @param avatarId Avatar ID.
 */
export function beginAvatarPoll(dispatch: HomeDispatch, avatarId: string) {
  // End previous interval.
  endAvatarPoll(dispatch);

  log.info('Avatar poll begin');

  dispatch(homeActions.beginAvatarBuild());

  // initialize a new interval with the latest avatar request
  state.timer = setInterval(async () => {
    const avatar = (await fetchAvatar(avatarId))!;

    if (avatar.smplShapeStatus !== 'COMPLETED') {
      return;
    }

    // Avatar completed.
    endAvatarPoll(dispatch);

    log.info('Avatar poll ended');

    // Update avatar.
    updateAvatar(dispatch, avatar);
  }, GARMENT_FIT_POLL_MILLISECONDS);
}

/**
 * End avatar polling.
 */
export function endAvatarPoll(dispatch: HomeDispatch) {
  if (state.timer) {
    // clear interval
    clearInterval(state.timer);
    state.timer = undefined;

    dispatch(homeActions.endAvatarBuild());
  }
}
